import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { PageEvent } from '@angular/material/paginator';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import { AngularMaterialModule } from 'src/app/module/angular-material/angular-material.module';
import { PaginatorConfig } from 'src/app/shared/model/paginator-config';
import { SharedModule } from 'src/app/shared/shared.module';
import { SearchedProperty } from '../../interface/new-order.interface';
import { NewOrderState } from '../../state/new-order.state';

@Component({
  selector: 'app-property-table',
  standalone: true,
  imports: [CommonModule, AngularMaterialModule, SharedModule],
  templateUrl: './property-table.component.html',
  styleUrls: ['./property-table.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PropertyTableComponent {
  paginationInfo!: PaginatorConfig | null;
  displayedColumns: string[] = [
    'select',
    'slNo',
    'address',
    'image',
    'apn',
    'source',
    'mlsNo',
    'propertyType',
    'bed',
    'bath',
    'gla',
    'lotSize',
    'lastSaleDate',
    'lastSalePrice',
    'ownerName',
  ];
  selectedIndex: number = -1;

  @Input() properties!: SearchedProperty[];
  @Input() count!: number;
  @Input() scope!: string;
  @Output() propertySelected: EventEmitter<SearchedProperty> = new EventEmitter<SearchedProperty>();

  constructor(
    public newOrderState: NewOrderState,
    private _sanitizer: DomSanitizer
  ) {}

  ngOnChanges() {
    this.displayedColumns = this.displayedColumns.filter((col) => {
      if (this.scope === 'COMPARABLE') {
        return col !== 'image'; // Exclude 'image' for 'COMPARABLE' scope
      } else {
        return col !== 'select'; // Exclude 'select' for other scopes
      }
    });

    this.selectedIndex = -1;
    this.paginationInfo = this.newOrderState.searchPropertyPagination;
  }

  pageEventHandler(event: PageEvent) {
    this.selectedIndex = -1;
    this.paginationInfo = { pageSize: event.pageSize, pageIndex: event.pageIndex };
    this.newOrderState.searchPropertyPagination = this.paginationInfo;
  }

  _getImageUrl(url: string): SafeUrl {
    if (url) return this._sanitizer.bypassSecurityTrustUrl(url + '&width=100');
    return '../../assets/noimage.png';
  }
}
